import script from "./MainMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=8fd06ba8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fd06ba8"]])

export default __exports__